import api from '../../common/libs/api.js';
import localforage from 'localforage';
import utils from '@/common/libs/utils'
import {responseResultValidate} from '@/common/libs/common.js';
import CityCodeData from '@/common/libs/CityCodeData';
const mine = {
  state: {
    state: { //保存登录之后我的信息

    },
    token: 1,
    studentCardInfo: {}
  },
  mutations: {
    changeToken(mine, token) {
      mine.token = token;
    },
    addMine(mine, preload) {
      mine.state = preload.state;
    },
    getStudentCardInfo(mine, preload) {
      mine.studentCardInfo = JSON.parse(JSON.stringify(preload.data));

      let cardCityCode = mine.studentCardInfo.cityCode; //学员卡的cityCode

      //学员卡有城市，切换页头城市  
      //兼容 其他 校区 0086
      if (cardCityCode && cardCityCode.length != 0) {
        utils.cookie.set('cardChangeCity', 1, '.izhikang.com', '/', 24*7); //不展示定位弹框
        utils.cookie.set('cityCode', cardCityCode, '.izhikang.com', '/', 24*7);

        let cardCityWord = CityCodeData.getCityByCode(cardCityCode).first_word;
        let pathEnd = preload.routerPath.split('/').slice(2).join('/');
        
        let newPath = `/${cardCityWord}/${pathEnd}`;

        if (newPath != location.pathname) {
          location.href = newPath;
        }

      } 
      // else { //如果学员卡的城市是空或者0086，都不改变右上角的城市
        
      //   if (preload.routerPath != location.pathname) {
      //     location.href = preload.routerPath;
      //   }
        
      //   utils.cookie.set('cardChangeCity', 0, '.izhikang.com', '/', 24*7);
      // }

     utils.cookie.set('canSwitchCity', mine.studentCardInfo.canSwitchCity, '.izhikang.com', '/', 24*7);
    }
  },
  actions: {
    getUseInfo(context) {
      return api.apiMethod.getUserInfo.post().then(res => {
        if (res.data.code == 0) {
          context.commit('addMine', { state: res.data.data });
          context.commit('changeToken', 1); //恢复正常token
          localforage.setItem('izk-user', res.data.data);
        } else if (res.data.code == 20007) {
          //token过期，
          utils.cookie.del('token', '.izhikang.com', '/');
          context.commit('changeToken', 2);
        } else {
          utils.cookie.del('token', '.izhikang.com', '/');
          context.dispatch('toast', { title: res.data.msg, show: true });
        }
      });
    },
    getStudentCardInfo(context, routerPath) {
      context.commit('isShowLoading', true);
      return api.apiMethod.getStudentCardInfo.get().then(res => {  
        context.commit('isShowLoading', false);
        if (responseResultValidate(res.data, {name: 'mine'})){ 
          if (res.data.errcode == 0) {
            context.commit('getStudentCardInfo', {data: res.data.data, routerPath: routerPath});
          } else {
            context.dispatch('toast', { title: res.data.msg, show: true });
          }
        }
      });
    }
  }
}

export default mine;


// WEBPACK FOOTER //
// ./src/stores/modules/mine.js